// Copyright 2019 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class UserWorkflowModuleCatalog {
    static CreditsStatusModule: IWorkflowModuleConfig = {
        name: "credit_status",
        modulePath: PLATFORM.moduleName("modules/workflows/Credits/Status/CreditsStatusModule"),
        title: "Credits Status",
        moduleType: WorkflowModuleType.User,
        requireSignIn: true,
    };

    static UserInformationModule: IWorkflowModuleConfig = {
        name: "userinformation",
        modulePath: PLATFORM.moduleName("modules/workflows/UserManagement/UserInformation/UserInformationModule"),
        title: "User Information",
        moduleType: WorkflowModuleType.User,
        requireSignIn: true,
    };

    static NotificationModule: IWorkflowModuleConfig = {
        name: "notification",
        modulePath: PLATFORM.moduleName("modules/workflows/UserManagement/Notification/NotificationModule"),
        title: "Notification",
        moduleType: WorkflowModuleType.User,
    };

    static FeatureStoreModule: IWorkflowModuleConfig = {
        name: "feature-store",
        modulePath: PLATFORM.moduleName("modules/workflows/UserManagement/FeatureStore/FeatureStoreModule"),
        title: "Feature Store",
        moduleType: WorkflowModuleType.User,
        isFullScreen: true,
    };
}
